
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.781 12c0 5.523-4.477 10-10 10s-10-4.477-10-10 4.477-10 10-10 10 4.477 10 10zm-11.156 5.295l7.419-7.42a.645.645 0 000-.912l-.913-.912a.645.645 0 00-.912 0l-6.05 6.05-2.826-2.824a.645.645 0 00-.912 0l-.912.912a.645.645 0 000 .912l4.193 4.194c.252.252.66.252.913 0z","fill":"#282E3E"}})])
          )
        }
      }
    